import { lang } from '../lang/lang.nl'

export const sidenavConfig = [
    { title: lang.nav.workers, path: '/werknemers', icon: 'tool', module: 'employee', id:'tab-workers'},
    { title: lang.nav.clients, path: '/klanten', icon: 'users', module: 'customer', id:'tab-clients'},
    { title: lang.nav.projects, path: '/projecten', icon: 'briefcase', module: 'project', id:'tab-projects'},
    { title: lang.nav.seals, path: '/afdichtingen', icon: 'box', module: 'firePartition', id:'tab-seals'},
    { title: lang.nav.qr, path: '/qr', icon: 'printer', module: 'printQr', id:'tab-qr'}
]